<div class="flex flex-col">
    <ng-container *ngFor="let action of actions">
        <div class="box-border border-b border-solid border-black border-opacity-10 dark:border-contrast-yellow"></div>
        <div class="flex w-full" [ngClass]="{ 'md:w-auto': mode === 'default' }">
            <ion-button
                class="w-full"
                [attr.aria-label]="action.text"
                [ngClass]="{ 'md:w-auto': mode === 'default' }"
                [disabled]="action.disabled"
                (click)="invokeHandler(action)"
                fill="clear">
                <ion-label class="normal-case text-secondary dark:text-contrast-yellow" [ngClass]="action.cssClass">
                    {{ action.text }}
                </ion-label>
            </ion-button>
        </div>
    </ng-container>
</div>
